// libs
import { createContext } from '@lyearn/core/utils/context';

// types
import { AIEditorContextProps } from '../types';

export const [AIEditorContextProvider, useAIEditorContext] =
  createContext<AIEditorContextProps>('AIEditorContext');
